module.exports = __webpack_public_path__ + "static/media/trianglify.080a60a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trianglify/trianglify.svg
// module id = 452
// module chunks = 0